/*
 * Confidential and Proprietary.
 * Do not distribute without Bloom Harbor Gifts consent.
 * Copyright Bloom Harbor Gifts 2019. All rights reserved.
 */

/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import Dialog from '@material-ui/core/Dialog';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import MenuItem from '@material-ui/core/MenuItem';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';
import {
    object, bool, func, string,
} from 'prop-types';

import * as commonSelectors from '../../../../../../../../state/ducks/Common/Common-Selectors';
import * as qasAddressSearchActions from '../../../../../../../../state/ducks/Common/ducks/AddressSearchQAS/AddressSearchQAS-Actions';
import { trackEvent } from '../../../../../../../../state/ducks/TagManager/ducks/TagManager/TagManager-Actions';

const styles = (theme) =>  ({
    modalBox: {
        margin: '10px !important',
        maxHeight: 'calc(100% - 96px)',
        minHeight: 'calc(100% - 96px)',
        maxWidth: '810px',
        width: 'auto',
        minWidth: '460px',
        [theme.breakpoints.down('sm')]: {
            minWidth: '320px',
        },
    },
    header: {
        fontFamily: theme.typography.fontFamily,
        borderBottom: `solid 2px ${theme.palette.cms?.primary || theme.palette.colorPrimary}`,
        textTransform: 'uppercase',
        fontSize: '14px',
        fontWeight: '600',
        padding: '5px',
        textAlign: 'center',
        margin: '5px',
    },
    dialogContent: {
        overflowY: 'auto',
        padding: '5px',
        margin: '5px',
    },
    address: {
        fontFamily: theme.typography.fontFamily,
        fontSize: '14px',
        fontWeight: '300',
        color: theme.palette.colorNeutral80,
        lineHeight: '18px',
    },
    addressInfo: {
        fontSize: '14px',
        fontWeight: '600',
    },
    orTextSplitter: {
        margin: '5px 0px',
        textAlign: 'center',
    },
    addressList: {
        fontFamily: theme.typography.fontFamily,
        padding: '5px 6px 0px',
        fontSize: '14px',
        borderBottom: `solid 1px ${theme.palette.colorNeutral40}`,
    },
    buttonActionSection: {
        textAlign: 'center',
        margin: '10px 0px',
    },
    editAddressQas: {
        marginRight: '15px',
        backgroundColor: theme.palette.primaryButton,
        fontWeight: '600',
        '&:hover, &:focus': {
            backgroundColor: theme.palette.primaryButton,
            color: theme.palette.white,
        },
    },
    keepAddressQas: {
        marginRight: '5px',
        backgroundColor: theme.palette.colorNeutral40,
        fontWeight: '600',
        '&:hover, &:focus': {
            backgroundColor: theme.palette.cms?.primary || theme.palette.colorPrimary,
            color: theme.palette.white,
        },
    },
    shipToAddress: {
        margin: '10px 0px',
    },
    suggestionListContainer: {
        paddingBottom: '40px',
    },
    [theme.breakpoints.down('md')]: {
        editAddressQas: {
            margin: '10px auto',
        },
        keepAddressQas: {
            margin: '10px auto',
        },
    },
});

// eslint-disable-next-line react/prefer-stateless-function
class QasAddressVerificationModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            impressionEventFired: false,
        };
    }

    componentDidUpdate() {
        const { showAddressValidation, track } = this.props;
        const { impressionEventFired } = this.state;
        if (showAddressValidation && !impressionEventFired) {
            track({
                eventCategory: 'Checkout',
                eventAction: 'Address Verification Modal',
                eventLabel: 'Impression',
            });
            this.setState({ impressionEventFired: true });
        } else if (!showAddressValidation && impressionEventFired) {
            // fire event if click on edit address and then modal shows up again and only update if modal closed
            this.setState({ impressionEventFired: false });
        }
    }

    getSuggestionList = (suggestionList, actionsQasAddress, handleSaveAddress) => {
        const { classes, track } = this.props;
        if (suggestionList && suggestionList.results && suggestionList.count > 0) {
            return suggestionList.results.map((address) => (
                <MenuItem
                    className={classes.addressList}
                    key={address.suggestion}
                    onClick={() => {
                        actionsQasAddress.selectRecommandedAddressQasVerification(address, handleSaveAddress);
                        track({
                            eventCategory: 'Checkout',
                            eventAction: 'Clicked on Address',
                            eventLabel: address.suggestion,
                        });
                    }}
                >
                    {address.suggestion}
                </MenuItem>
            ));
        }
        return null;
    }

    /*
    shipToAddress = (recipient) => {
        let addressLine = '';
        if (recipient.address1) addressLine = `${recipient.address1}`;
        if (recipient.address2) addressLine = `${addressLine}, ${recipient.address2}`;
        if (recipient.city) addressLine = `${addressLine}, ${recipient.city}`;
        if (recipient.state) addressLine = `${addressLine}, ${recipient.state}`;
        if (recipient.zipCode) addressLine = `${addressLine}, ${recipient.zipCode}.`;
        return addressLine;
    }
    */
    shipToAddress = (recipient, classes) => {
        let isPoBox = false;
        let PoBoxAddressLine1 = '';
        if (recipient?.locationType?.includes('P.O.Box')) {
            isPoBox = true;
            const extraPoboxText = recipient.address1.slice(7, 13).toLowerCase();
            const defaultPoboxText = recipient.address1.slice(0, 6).toLowerCase();
            if (((/(po)(\s|box)+/g).test(extraPoboxText))) {
                PoBoxAddressLine1 = recipient.address1.replace('PO Box', '').trim();
            } else if (!(/(po)(\s|box)+/g).test(defaultPoboxText)) {
                PoBoxAddressLine1 = `PO Box ${recipient.address1}`;
            } else {
                PoBoxAddressLine1 = recipient.address1;
            }
        }
        return (
            <Grid className={classes.shipToAddress}>
                <Typography className={classes.address} align="left">
                    {isPoBox ? `${PoBoxAddressLine1}` : `${recipient.address1}`}
                </Typography>
                {recipient.address2
                    ? (
                        <Typography className={classes.address} align="left">
                            {`${recipient.address2}`}
                        </Typography>
                    ) : null}
                <Typography className={classes.address} align="left">
                    {`${recipient.city}, ${recipient.state} ${recipient.zipCode}`}
                </Typography>
            </Grid>
        );
    };

    render() {
        const {
            classes,
            suggestionList,
            showAddressValidation,
            recipientForm,
            formFieldValues,
            actionsQasAddress,
            handleSaveAddress,
            typeData,
            track,
        } = this.props;

        let dataValues = { ...recipientForm };
        if (typeData === 'popup') {
            dataValues = { ...formFieldValues };
        }
        return (
            <Grid>
                {showAddressValidation
                    && (
                        <Dialog
                            id={`DialogQASAddress${typeData}`}
                            classes={{
                                paper: classes.modalBox,
                            }}
                            open={showAddressValidation}
                            data-testid={`DialogQASAddress${typeData}`}
                        >
                            <Typography className={classes.header}>
                                Address Verification
                            </Typography>
                            <Grid className={classes.dialogContent}>
                                <Typography className={classes.addressInfo}>
                                    We could not find a match to the address:
                                </Typography>
                                {this.shipToAddress(dataValues, classes)}
                                <Typography className={classes.addressInfo}>
                                    Please choose one of the options below to proceed.
                                </Typography>
                                <Grid className={classes.buttonActionSection}>
                                    <Button
                                        name="edit-address-qas"
                                        // variant="outlined"
                                        variant="contained"
                                        color="primary"
                                        data-test="checkout-recipient-address-edit"
                                        className={classes.editAddressQas}
                                        onClick={() => {
                                            actionsQasAddress.editAddressQasVerification();
                                            track({
                                                eventCategory: 'Checkout',
                                                eventAction: 'Address Verification Modal',
                                                eventLabel: 'Edit Address',
                                            });
                                        }}
                                    >
                                        Edit Address
                                    </Button>
                                    <Button
                                        name="keep-address-qas"
                                        // variant="outlined"
                                        variant="contained"
                                        // color="primary"
                                        className={classes.keepAddressQas}
                                        data-test="checkout-recipient-address-keep"
                                        onClick={() => {
                                            actionsQasAddress.keepAddressQasVerification(handleSaveAddress);
                                            track({
                                                eventCategory: 'Checkout',
                                                eventAction: 'Address Verification Modal',
                                                eventLabel: 'Keep Address',
                                            });
                                        }}
                                    >
                                        Keep Address
                                    </Button>
                                </Grid>
                                {(suggestionList && suggestionList.results && suggestionList.count > 0)
                            && (
                                <Grid>
                                    <Typography className={classes.orTextSplitter}>
                                        Or
                                    </Typography>
                                    <Typography className={classes.addressInfo} data-test="checkout-recipient-recommended-address">
                                        Select a Recommended Address:
                                    </Typography>
                                    <Grid className={classes.suggestionListContainer}>
                                        { this.getSuggestionList(suggestionList, actionsQasAddress, handleSaveAddress) }
                                    </Grid>
                                </Grid>
                            )}
                            </Grid>
                        </Dialog>
                    )}
            </Grid>
        );
    }
}

QasAddressVerificationModal.propTypes = {
    classes: object.isRequired,
    suggestionList: object.isRequired,
    showAddressValidation: bool.isRequired,
    recipientForm: object.isRequired,
    formFieldValues: object,
    typeData: string,
    actionsQasAddress: object.isRequired,
    handleSaveAddress: func,
    track: func,
};

QasAddressVerificationModal.defaultProps = {
    handleSaveAddress: () => {},
    formFieldValues: {},
    typeData: '',
    track: () => {},
};

/* eslint-disable arrow-parens */
const mapStateToProps = state => ({
    suggestionList: commonSelectors.getQasSearchSuggestion(state),
    showAddressValidation: commonSelectors.getShowValidatedAddressSuggestion(state),
    recipientForm: commonSelectors.getRecipientForm(state),
});

const mapDispatchToProps = dispatch => ({
    actionsQasAddress: bindActionCreators(qasAddressSearchActions, dispatch),
    track: bindActionCreators(trackEvent, dispatch),
});

export default compose(
    withStyles(styles),
    connect(mapStateToProps, mapDispatchToProps),
)(QasAddressVerificationModal);
